document.addEventListener('DOMContentLoaded', function() {
    // 自サイトのホスト名（本番ドメイン・プレビュー用ドメインなど）。ここに載っているホストの
    // 絶対URLは相対パスに直してから取得する。
    const SAME_SITE_HOSTS = ['lumiere8.com', 'www.lumiere8.com'];

    // 絶対URL（https://lumiere8.com/…）のままだと、ローカルやプレビュー環境では別オリジンへの
    // fetch になりCORSでブロックされて記事情報を取得できない。自サイト宛てなら相対パスに直す。
    function normalizeUrl(rawUrl) {
        const trimmed = (rawUrl || '').trim();
        if (!trimmed) return '';
        if (!/^https?:\/\//i.test(trimmed)) return trimmed; // もともと相対パスならそのまま
        try {
            const parsed = new URL(trimmed);
            const isSameSite = parsed.host === window.location.host
                || SAME_SITE_HOSTS.indexOf(parsed.host) !== -1
                || /\.myshopify\.com$/i.test(parsed.host);
            return isSameSite ? parsed.pathname + parsed.search : trimmed;
        } catch (e) {
            return trimmed;
        }
    }

    const placeholders = document.querySelectorAll('.related-article-placeholder');
    if (placeholders.length > 0) {
        placeholders.forEach(placeholder => {
            // リンク先は data-url を優先し、無ければ枠の中の控えリンク（aタグのhref）を使う。
            // Shopifyの本文エディタは data-url のような独自属性を保持できず、管理画面で本文を保存すると
            // data-url だけが消える。href は保持されるため、控えリンクがあれば表示を維持できる。
            const fallbackLink = placeholder.querySelector('a[href]');
            const rawUrl = placeholder.getAttribute('data-url') || (fallbackLink ? fallbackLink.getAttribute('href') : '');
            const url = normalizeUrl(rawUrl);
            if (!url) return; // リンク先が分からない場合は何もしない（fetch(null)で無駄な404を出さない）。
            fetch(url)
                .then(response => {
                    // 取得に失敗したら控えリンクを残す（404ページの情報でカードを作らない）。
                    if (!response.ok) throw new Error('HTTP ' + response.status + ' : ' + url);
                    return response.text();
                })
                .then(data => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');
                    const title = doc.querySelector('meta[property="og:title"]') ? doc.querySelector('meta[property="og:title"]').content : 'No title';
                    const image = doc.querySelector('meta[property="og:image"]') ? doc.querySelector('meta[property="og:image"]').content : 'default-image.jpg';
                    const excerpt = doc.querySelector('meta[property="og:description"]') ? doc.querySelector('meta[property="og:description"]').content : 'No excerpt available';

                    // 画像URLを300x300に変換
                    let resizedImage = image;
                    if (image.includes('cdn.shopify.com')) {
                        resizedImage = image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_300x300$1$2');
                    }

                    placeholder.innerHTML = `
                        <div class="related-article">
                            <a href="${url}" class="related-article-link">
                                <div class="related-article-image-container">
                                    <img src="${resizedImage}" alt="${title}" loading="lazy" class="related-article-image">
                                </div>
                                <div class="related-article-content">
                                    <h3 class="related-article-title">${title}</h3>
                                    <p class="related-article-excerpt">${excerpt}</p>
                                </div>
                            </a>
                        </div>
                    `;
                })
                .catch(error => console.error('Error fetching article data:', error));
        });
    }
});
